
import { computed, defineComponent, onMounted, PropType, Ref, ref } from 'vue'
import DButton from './DButton.vue'
import AddIcon from '@/components/Icons/AddIcon.vue'
import EyeIcon from '@/components/Icons/EyeIcon.vue'

export default defineComponent({
  components: { DButton, AddIcon, EyeIcon },
  props: {
    modelValue: {
      type: [String, Number],
      required: true
    },
    options: {
      type: Array as PropType<{ label: string, value: string | number}[]>,
      required: true
    },
  },
  emits: ['update:model-value'],
  setup (props, { emit }) {



    const handleClick = (value: string | number) => {
      // console.log('handleClick', value)
      emit('update:model-value', value)
    }

    return {
      handleClick,
    }
  }
})

